import axios from 'axios';
import router from '../../router.js';
import common from 'assets/js/common';

// axios instance
let instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

// add a request interceptor
instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    // console.log('Current headers:', config.headers)

    var params = config.params;
    if (params == undefined || params == null) {
        params = {}
    }
    params['site-id'] = 'ec';
    params['path'] = router.app.$route.path;
    params['client-url'] = window.location.href;

    var query = router.app.$route.query;
    if (query != undefined && query != null) {
        if (query['pageNo'] != undefined) {
            params['pageNo'] = query['pageNo'];
        }
    }

    config.params = params;

    var site = router.app.$route.path.split("/")[1];
    config.headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': `${localStorage['aution-' + site.toLowerCase()] || ''}`,
        'UI-Language': `${localStorage.language || 'JP'}`
    };
    if (config.method === 'post') {
        // 配列型のプロパティのnullの要素にブランク設定(WAF対応)
        common.fillArrays(config.data);
    }

    // console.log('url:', config.url)

    // console.log('Header:', config.headers);

    return config;

}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// add a response interceptor
instance.interceptors.response.use(function (response) {
    // Do something with response data
    var token = response.headers.authorization;
    if (token != undefined && token != null) {
        // console.log('Request response token:', token);
        var site = router.app.$route.path.split("/")[1];
        localStorage['aution-' + site.toLowerCase()] = token;
    }
    return response;
}, function (error) {
    // Do something with response error
    // console.log('ERROR:', error)
    return Promise.reject(error);
});


export default instance